import { render, staticRenderFns } from "./SmartDuo.vue?vue&type=template&id=68709664&"
import script from "./SmartDuo.vue?vue&type=script&lang=js&"
export * from "./SmartDuo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports